<template>
  <div>
    <slot
      name="content"
      :blogDownloadForm="blogDownloadForm"
      :articleShowMore="articleShowMore"
      :showSuccessMsg="showSuccessMsg"
      :closeModal="closeModal"
    ></slot>
  </div>
</template>
<script setup>

import {ref} from 'vue'
import {useFormSubmit} from '../../composables/useFormSubmit'

const showSuccessMsg = ref(false)
const { blogDownloadForm, closeModal } = useFormSubmit()

const articleShowMore = (e) => {
  const articles = e.target.parentElement.getElementsByClassName('blog__article-tile');
  for(let i = 0; i < articles.length; i++) {
    articles[i].style.display = 'block';
  }
  e.target.style.display = 'none';
}

</script>
